var App = App || {};

App.WidgetPastEvents = (function ($) {
    'use strict';

    function Init(widget) {
        Animate(widget);
        Carousel(widget);
    }

    function Carousel(widget) {

        const carousels = widget.find('.past-events__promos__carousel.splide');

        if (!carousels.length) {
            return;
        }

        carousels.each(function () {

            const carousel = this;
            const slides = carousel.querySelectorAll('.splide__slide');

            if (!slides.length) {
                return;
            }
  
            if (slides.length <= 3) {
                carousel.classList.add('no-carousel');
                return;
            }


            const progressBar = carousel.querySelector('.splide-progress__bar');
            const currentNumber = carousel.querySelector('.splide-progress__current');
            const totalNumber = carousel.querySelector('.splide-progress__total');

            const splide = new Splide(carousel, {
                type: 'slide',
                gap: 0,
                perMove: 1,
                focus: 'left',
                arrows: true,
                pagination: false,
                drag: true,
                snap: true,
                rewind: true,
                speed: 500,
                autoWidth: true,
                breakpoints: {
                    580: {
                        fixedWidth: '100%',
                        autoWidth: false
                    },
                }
            });

            function updateProgress() {

                const current = splide.index + 1;
                const total = slides.length;

                if (currentNumber) {
                    currentNumber.textContent = current;
                }

                if (totalNumber) {
                    totalNumber.textContent = total;
                }

                if (progressBar) {
                    const progress = (current / total) * 100;
                    progressBar.style.width = progress + '%';
                }
            }

            splide.on('overflow', function (isOverflow) {

                splide.go(0);

                splide.options = {
                    arrows: isOverflow,
                    drag: isOverflow,
                    clones: isOverflow ? undefined : 0,
                    label: 'Past Events Carousel'
                };

                carousel.classList.toggle('is-carousel', isOverflow);
                carousel.classList.toggle('no-carousel', !isOverflow);

                updateProgress();
            });

            splide.on('mounted', updateProgress);
            splide.on('move', updateProgress);
            splide.mount();
        });
    }

    function Animate(widget) {
        const animate = widget.find(".past-events__promos__carousel");

        animate.ZagScrollAnimate({
            targets: [
                {
                    selector: ".splide__slide",
                    type: "animate__fadeInLeft",
                    stagger: 200
                }
            ]
        });
    }

    return {
        Init: Init
    };

})(jQuery);